import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import React, { useState, useEffect, useContext } from 'react';
import { Label, Input, Card, CardBody, Button } from 'reactstrap';
import { useAuth0 } from '../../../../../auth0/reactAuth0Spa';
import { checkLoginForError, formatBearerToken } from '../../../../../Common.functions';
import { DepartmentContext } from '../../../../../DepartmentWrapper';
import { fetchDataAgnostic, putData } from '../../../../../Services/dataApi';
import style from './Advanced.style';
import { toast } from 'react-toastify';
import { applicationSystems, programTypes } from '../../../../../enums';

dayjs.extend(utc);
dayjs.extend(timezone);

const Advanced = ({ updateChanges }) => {
  const [settings, setSettings] = useState({});
  const [enableTagFilter, setEnableTagFilter] = useState(false);

  const [terminateVirtualMeeting, setTerminateVirtualMeeting] = useState('End of Passing');
  const [virtualMeetingMode, setVirtualMeetingMode] = useState('Disabled');
  const [firstBlockEarlyJoinInMinutes, setFirstBlockEarlyJoinInMinutes] = useState(5);

  const [applicationSystem, setApplicationSystem] = useState('ERAS');
  const [programType, setProgramType] = useState('Residency');
  const [time, setTime] = useState(
    dayjs()
      .tz(dayjs.tz.guess())
      .format('HH:mm'),
  );
  const [GMT, setGMT] = useState('GMT');

  const [isSaving, setIsSaving] = useState(false);

  // Alert functionality replaced with toast
  // DB Value-----UI Dropdown Value
  // Disabled------Disabled
  // Internal-------RezRATE Managed Meetings
  // External-------Coordinator Managed Breakout Rooms (Single URL)
  // ExternalColumn------Coordinator Managed Breakout Rooms (Multiple URL)

  const virtualMeetingModes = [
    {
      value: 'Disabled',
      label: 'Disabled',
    },
    {
      value: 'Internal',
      label: 'RezRATE Managed Meetings', // Auto create w/ zoom
    },
    {
      value: 'External',
      label: 'Coordinator Managed Breakout Rooms (Single URL)', // Go to Visit Break Room
    },
    {
      value: 'ExternalColumn',
      label: 'Coordinator Managed Breakout Rooms (Multiple URL)', // Go to per-column URL, not yet implemented.
    },
  ];

  const joinMeetingMinutes = [5, 10, 15];

  const dContext = useContext(DepartmentContext);
  const { getTokenSilently, loginWithRedirect } = useAuth0();

  useEffect(() => {
    getDepartmentSettings();
  }, []);

  useEffect(() => {
    if (settings && Object.keys(settings).length > 0) {
      const {
        EnableTagFiltering,
        ApplicationSystem,
        TimeZone,
        FirstBlockEarlyJoinInMinutes,
        ProgramType,
        VirtualMeetingMode,
      } = settings;
      setEnableTagFilter(EnableTagFiltering);
      if (ApplicationSystem) {
        setApplicationSystem(ApplicationSystem);
      }

      if (ProgramType) {
        setProgramType(ProgramType);
      }

      if (TimeZone) {
        setGMT(TimeZone);
      }

      if (FirstBlockEarlyJoinInMinutes) {
        setFirstBlockEarlyJoinInMinutes(FirstBlockEarlyJoinInMinutes);
      }

      if (VirtualMeetingMode) {
        setVirtualMeetingMode(VirtualMeetingMode);
      }
    }
  }, [settings]);

  useEffect(() => {
    if (virtualMeetingMode === 'Disabled' && terminateVirtualMeeting !== 'Disabled') {
      setTerminateVirtualMeeting('Disabled');
    }
  }, [virtualMeetingMode]);

  const getDepartmentSettings = () => {
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/settings',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setSettings(res.data[0]);
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const saveDepartmentSettings = () => {
    const payload = { EnableTagFiltering: enableTagFilter };
    if (GMT) {
      payload.TimeZone = GMT;
    }
    if (applicationSystem) {
      payload.ApplicationSystem = applicationSystem;
    }

    if (firstBlockEarlyJoinInMinutes) {
      payload.FirstBlockEarlyJoinInMinutes = firstBlockEarlyJoinInMinutes;
    }

    if (programType) {
      payload.ProgramType = programType;
    }

    if (virtualMeetingMode) {
      payload.VirtualMeetingMode = virtualMeetingMode;
    }

    if (terminateVirtualMeeting) {
      payload.TerminateVirtualMeeting = terminateVirtualMeeting;
    }

    setIsSaving(true);
    getTokenSilently()
      .then((token) => {
        putData(
          'department/settings',
          { pk_Department: dContext.department.pk_Department, pk_Season: dContext.season.pk_Season },
          {
            payload,
          },
          formatBearerToken(token),
        )
          .then((res) => {
            setIsSaving(false);

            const { EnableTagFiltering, ApplicationSystem, TimeZone, FirstBlockEarlyJoinInMinutes } = res;
            setEnableTagFilter(EnableTagFiltering);
            if (ApplicationSystem) {
              setApplicationSystem(ApplicationSystem);
            }

            if (TimeZone) {
              setGMT(TimeZone);
            }

            if (FirstBlockEarlyJoinInMinutes) {
              setFirstBlockEarlyJoinInMinutes(FirstBlockEarlyJoinInMinutes);
            }

            getDepartmentSettings();
            toast.success('Updated Settings!');
            updateChanges('advancedSettings', false);
          })
          .catch((err) => {
            toast.error('Update Settings failed!');
            setIsSaving(false);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  return (
    <Card>
      <CardBody style={{ height: '50vh' }}>
        <div>
          {/* <Card style={{ marginBottom: 20 }}>
            <CardBody>
              <div style={style.simpleRow}>
                <div style={style.inputContainers}>
                  <Input
                    // disabled={isUpdating}
                    type="switch"
                    id="toggleTagFiltering"
                    name="toggleTagFiltering"
                    checked={enableTagFilter}
                    label={<b>Tag Filter: {toggleTag}</b>}
                    onChange={(e) => {
                      const newValue = !enableTagFilter;
                      setEnableTagFilter(newValue);
                      if (newValue != settings.EnableTagFiltering) {
                        updateChanges('advancedSettings', true);
                      }
                    }}
                  />
                </div>
              </div>
            </CardBody>
          </Card> */}

          <div style={style.simpleRow}>
            <div style={{ ...style.simpleColumn, width: '35%', marginRight: 20 }}>
              <Card>
                <CardBody>
                  <div style={{ ...style.simpleColumn, width: '100%', marginRight: 20 }}>
                    <div style={style.simpleRow}>
                      <div style={{ ...style.simpleColumn, width: '100%', marginRight: 20 }}>
                        <div style={style.inputContainers}>
                          <Label for="virtualMeetingMode"> Virtual Meeting Mode:</Label>
                          <Input
                            type="select"
                            name="select"
                            id="virtualMeetingMode"
                            value={virtualMeetingMode}
                            onChange={(e) => {
                              setVirtualMeetingMode(e.target.value);
                            }}
                          >
                            {virtualMeetingModes.map((mode) => {
                              return <option value={mode.value}>{mode.label}</option>;
                            })}
                          </Input>
                        </div>
                      </div>
                    </div>
                    {virtualMeetingMode === 'Internal' ? (
                      <>
                        <div style={style.simpleRow}>
                          <div style={{ ...style.simpleColumn, width: '100%', marginRight: 20 }}>
                            <div style={style.inputContainers}>
                              <Label for="terminateVirtualMeeting"> Terminate Virtual Meetings at: </Label>
                              <Input
                                disabled={virtualMeetingMode !== 'RezRATE Managed Meetings'}
                                type="select"
                                name="select"
                                id="terminateVirtualMeeting"
                                value={'End of Passing'} // value={terminateVirtualMeeting}
                                onChange={(e) => {
                                  setTerminateVirtualMeeting(e.target.value);
                                }}
                              >
                                <option value="End of Meeting">End of Meeting</option>
                                <option value="End of Passing">End of Passing period</option>
                              </Input>
                            </div>
                          </div>
                        </div>
                        <div style={style.simpleRow}>
                          <div style={{ ...style.simpleColumn, width: '100%', marginRight: 20 }}>
                            <div style={style.inputContainers}>
                              <Label for="firstJoin"> Display First Join Meeting Link </Label>
                              <Input
                                disabled={virtualMeetingMode === 'Disabled'}
                                type="select"
                                name="select"
                                id="firstJoin"
                                value={firstBlockEarlyJoinInMinutes}
                                onChange={(e) => {
                                  setFirstBlockEarlyJoinInMinutes(e.target.value);
                                }}
                              >
                                {joinMeetingMinutes.map((choice) => {
                                  return <option value={choice}>{`${choice} minutes early.`}</option>;
                                })}
                              </Input>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div style={{ height: 152 }} />
                    )}
                  </div>
                </CardBody>
              </Card>
            </div>

            <div style={{ ...style.simpleColumn, width: '40%', marginLeft: 30 }}>
              <Card>
                <CardBody>
                  <div style={style.simpleRow}>
                    <div style={{ ...style.simpleColumn, width: '50%', marginRight: 20 }}>
                      <div style={style.inputContainers}>
                        <Label for="matchType">Program Type</Label>
                        <Input
                          id="programType"
                          type="select"
                          value={programType}
                          placeholder="Program Type"
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setProgramType(e.target.value);
                            if (newValue != settings.ApplicationSystem) {
                              updateChanges('advancedSettings', true);
                            }
                          }}
                        >
                          {programTypes.map((programType) => {
                            return (
                              <option key={programType} value={programType}>
                                {programType}
                              </option>
                            );
                          })}
                        </Input>
                      </div>
                    </div>
                    <div style={{ ...style.simpleColumn, width: '45%' }}>
                      <div style={style.inputContainers}>
                        <Label for="applicationsystems">Application System</Label>
                        <Input
                          id="applicationsystems"
                          type="select"
                          value={applicationSystem}
                          placeholder="Application System"
                          onChange={(e) => {
                            const newValue = e.target.value;
                            setApplicationSystem(e.target.value);
                            if (newValue != settings.ApplicationSystem) {
                              updateChanges('advancedSettings', true);
                            }
                          }}
                        >
                          {applicationSystems.map((applicationSystem) => {
                            return (
                              <option key={applicationSystem.dataKey} value={applicationSystem.dataKey}>
                                {applicationSystem.label}
                              </option>
                            );
                          })}
                        </Input>
                      </div>
                    </div>
                  </div>
                  <div style={style.simpleRow}>
                    <div style={{ ...style.simpleColumn, width: '50%', marginRight: 20 }}>
                      <div style={style.inputContainers}>
                        <Label for="timezone">Timezone</Label>
                        <Input
                          id="timezone"
                          type="select"
                          placeholder="GMT"
                          value={GMT}
                          onChange={(e) => {
                            const newTime = dayjs()
                              .tz(e.target.value)
                              .format('HH:mm');
                            const newGMT = e.target.value;

                            setTime(newTime);
                            setGMT(e.target.value);

                            if (newGMT !== settings.TimeZone) {
                              updateChanges('advancedSettings', true);
                            }
                          }}
                        >
                          {dayjs.tz.names().map((name) => {
                            if (name.indexOf('US/') >= 0) {
                              const z =
                                dayjs()
                                  .tz(name)
                                  .utcOffset() / 60;
                              return (
                                <option value={name}>
                                  {name} (GMT {z > 0 ? `+ ${z}` : z})
                                </option>
                              );
                            }
                          })}
                        </Input>
                      </div>
                    </div>
                    <div style={{ ...style.simpleColumn, width: '45%' }}>
                      <div style={style.inputContainers}>
                        <Label for="time">Time</Label>
                        <Input
                          disabled
                          id="time"
                          type="time"
                          defaultValue={'1:02'}
                          placeholder="Time"
                          value={time}
                          onChange={(e) => {
                            //   handleChange('time', e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>

          <div style={{ ...style.simpleRow, marginTop: 30, alignItems: 'center', justifyContent: 'center' }}>
            <Button
              disabled={isSaving}
              color="success"
              style={{ width: 150 }}
              onClick={() => {
                saveDepartmentSettings();
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Advanced;
